import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const Index = lazy(() => import('components/productModule/productGroup/index'));

const ProductGroup = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<Index />
			</Suspense>
		</div>
	);
};

export default ProductGroup;
